import { RiyalImgBLK } from "../../../components/common/RiyalImg";

export default function PaymentTbl({ orderId, orderType, orderCreated, orderAmount, orderDetails, allServicesCategories, moment, t, i18n, orderStatus, allPaymentStatus }) {

    // Handle empty orderDetails safely
    const getServiceName = () => {
        if (!orderDetails || orderDetails.length === 0) {
            return "N/A";
        }

        const service = orderDetails[0]?.service;
        if (!service) {
            return "N/A";
        }

        const category = allServicesCategories?.find(cat => cat.en === service);
        return category ? (i18n.language === "ar" ? category.ar : category.en) : service;
    };

    // Get translated status and determine color
    const getStatusDisplay = () => {
        if (!allPaymentStatus || !orderStatus) return orderStatus;

        const statusObj = allPaymentStatus.find(status => status.en === orderStatus);
        return statusObj ? (i18n.language === "ar" ? statusObj.ar : statusObj.en) : orderStatus;
    };

    // Get color class based on status
    const getStatusColorClass = () => {
        switch (orderStatus) {
            case "Failed":
                return "text-danger fw-bold";
            case "Completed":
                return "text-success fw-bold";
            case "Pending":
                return "text-warning fw-bold";
            default:
                return "text-secondary";
        }
    };

    return (
        <>

            <tr>
                <td className="col" > {`${moment(orderCreated).format('YY')}${new Intl.NumberFormat("en-IN", { minimumIntegerDigits: 3 }).format(orderId,)}`}</td>
                <td className="col-2">
                    {moment(orderCreated).format('DD-MM-YYYY')}</td>
                <td className="col-5">{orderType === "services" ? t("Service") : t("Book")}
                    <br />
                    {orderType === "services" ?
                        (<span className="text-info">
                            {getServiceName()}</span>) : ""}

                </td>
                <td className="col">{orderAmount}  <RiyalImgBLK />
                </td>
                <td className={`col ${getStatusColorClass()}`}>{getStatusDisplay()}
                </td>

            </tr>

        </>
    );

}